import { render, staticRenderFns } from "./newUploadFile.vue?vue&type=template&id=dd49717c&scoped=true"
import script from "./newUploadFile.vue?vue&type=script&lang=js"
export * from "./newUploadFile.vue?vue&type=script&lang=js"
import style0 from "./newUploadFile.vue?vue&type=style&index=0&id=dd49717c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd49717c",
  null
  
)

export default component.exports